import { Col, Row, Typography } from 'antd';
import React from 'react';
import pinImage1 from 'assets/images/pin1.png';
import pinImage2 from 'assets/images/pin2.png';
import ButtonGlobal from '@shared/Button';
import { useCustomModal } from '@shared/Modal';
import { useTranslation } from 'react-i18next';

const { Text, Title } = Typography;

const InfoCard = ({ image, title, description }: { image: string; title: string; description: string }) => (
  <Col
    span={12}
    style={{
      display: 'flex',
      justifyContent: 'space-evenly',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '0 65px',
      height: 340,
    }}
  >
    <img src={image} alt="id-sample" style={{ width: '290px', height: '195px' }} />
    <Title level={5}>{title}</Title>
    <Text style={{ fontSize: '16px', textAlign: 'center' }}>{description}</Text>
  </Col>
);

function PersonalIdInfo() {
  const { closeModal } = useCustomModal()

  const { t } = useTranslation()

  return (
    <Row style={{ flexDirection: 'column' }}>
      <Row align="middle" justify="space-between">
        <InfoCard
          image={pinImage1}
          title={t('businessCardOrders.personalIdCardTitleOld')}
          description={t('businessCardOrders.personalIdCardDescriptionOld')}
        />
        <InfoCard
          image={pinImage2}
          title={t('businessCardOrders.personalIdCardTitleNew')}
          description={t('businessCardOrders.personalIdCardDescriptionNew')}
        />
      </Row>
      <Row justify="end" style={{ marginTop: 32 }}>
        <ButtonGlobal onClick={closeModal}>{t('common.close')}</ButtonGlobal>
      </Row>
    </Row>
  );
}

export default PersonalIdInfo;
